<template>

</template>

<script>
  export default {
    name: 'laoding',
    data() {
      return {
        load: true
      }
    },
    created() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
    },
    methods: {
      loadClose() {
        this.$toast.clear()
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/laoding.vue